module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-In-villa-activities-03.13aa096b.jpg";